(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    if (window.__navDropdownInit) return;
    window.__navDropdownInit = true;

    var desktop = window.matchMedia('(min-width: 750px)');
    var mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
    var HIDE_DELAY = 180;

    function hoverMode() {
      return desktop.matches && mouse.matches;
    }

    function setOpen(dd, open) {
      dd.classList.toggle('is-open', open);
      var btn = dd.querySelector('[data-nav-dd-toggle]');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeAll(except) {
      document.querySelectorAll('[data-nav-dd].is-open').forEach(function (dd) {
        if (dd !== except) setOpen(dd, false);
      });
    }

    function init(root) {
      root.querySelectorAll('[data-nav-dd]').forEach(function (dd) {
        if (dd.__navReady) return;
        dd.__navReady = true;

        var timer;
        var btn = dd.querySelector('[data-nav-dd-toggle]');
        var link = dd.querySelector('.nav-dd__link');

        // Hover to open / close (desktop with a mouse)
        dd.addEventListener('mouseenter', function () {
          if (!hoverMode()) return;
          clearTimeout(timer);
          closeAll(dd);
          setOpen(dd, true);
        });

        dd.addEventListener('mouseleave', function () {
          if (!hoverMode()) return;
          clearTimeout(timer);
          timer = setTimeout(function () { setOpen(dd, false); }, HIDE_DELAY);
        });

        // Arrow button: tap on touch devices, Enter/Space for keyboard
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var isMouseClick = e.detail > 0;
          if (hoverMode() && isMouseClick) {
            setOpen(dd, true);
            return;
          }
          var open = !dd.classList.contains('is-open');
          if (open && desktop.matches) closeAll(dd);
          setOpen(dd, open);
        });

        // Parent link navigates. If it has no real URL, it toggles instead.
        link.addEventListener('click', function (e) {
          var href = link.getAttribute('href');
          if (!href || href === '#') {
            e.preventDefault();
            btn.click();
          }
        });

        // Close when keyboard focus leaves the dropdown (desktop)
        dd.addEventListener('focusout', function (e) {
          if (desktop.matches && !dd.contains(e.relatedTarget)) setOpen(dd, false);
        });
      });
    }

    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });

    document.addEventListener('click', function (e) {
      if (!desktop.matches) return;
      document.querySelectorAll('[data-nav-dd].is-open').forEach(function (dd) {
        if (!dd.contains(e.target)) setOpen(dd, false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('[data-nav-dd].is-open');
      if (!open) return;
      setOpen(open, false);
      var btn = open.querySelector('[data-nav-dd-toggle]');
      if (btn) btn.focus();
    });

    var onBreakpoint = function () { closeAll(); };
    if (desktop.addEventListener) desktop.addEventListener('change', onBreakpoint);
  })();

  } catch(e) { console.error(e); }
})();
})();
